const DEFAULT_HUBSPOT_ACCOUNT_ID = "45344603";
const DEFAULT_HUBSPOT_CHATFLOW_ID = "70611511";

export const HUBSPOT_ACCOUNT_ID: string =
  (typeof import.meta.env.VITE_HUBSPOT_ACCOUNT_ID === "string" && import.meta.env.VITE_HUBSPOT_ACCOUNT_ID) ||
  DEFAULT_HUBSPOT_ACCOUNT_ID;
export const HUBSPOT_CHATFLOW_ID: string =
  (typeof import.meta.env.VITE_HUBSPOT_CHATFLOW_ID === "string" && import.meta.env.VITE_HUBSPOT_CHATFLOW_ID) ||
  DEFAULT_HUBSPOT_CHATFLOW_ID;
export const HUBSPOT_SCRIPT_SRC = `//js.hs-scripts.com/${HUBSPOT_ACCOUNT_ID}.js`;
export const HUBSPOT_SCRIPT_ID = "hs-script-loader";
export const HUBSPOT_INLINE_EMBED_ELEMENT_ID = "hs-support-container";
export const HUBSPOT_INLINE_EMBED_SELECTOR = `#${HUBSPOT_INLINE_EMBED_ELEMENT_ID}`;

export type SupportChatSource = "settings" | "sidebar";
